import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { tap } from 'rxjs/operators';
import { DesignChangeLogAction } from '../../../../Models/designChangeLogAction';
import { Utils } from '../../../../services/utils';

@Component({
  selector: 'app-recover-version-change-log',
  templateUrl: './recover-version-change-log.component.html',
  styleUrls: ['./recover-version-change-log.component.css']
})
export class RecoverVersionChangeLogComponent implements OnInit {

  @Input() modalTitle: string;
  objId: number;
  objMessage: string;
  error = '';
  bpId: number;
  bpVersion: number;
  bpDescription: string;
  bpName: string;
  bpChangeLog: string;
  filterText: string;
  actions: DesignChangeLogAction[];
  utilsFunctions = Utils;
  localTimeZone: string;

  constructor(
    public bsModalRef: BsModalRef,
    private bpService: BusinessProcessService
  ) { }

  ngOnInit() {
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.bpId = this.objId;
    this.bpVersion = Number(this.objMessage);

    this.bpService.getBusinessProcessChangeLog(this.bpId, this.bpVersion)
      .pipe(
        tap( bpChangeLog => {
          this.bpName = bpChangeLog.businessProcessName;
          this.bpDescription = bpChangeLog.businessProcessDescription;
          this.bpChangeLog = bpChangeLog.userChangeLog;
        }, error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.error = err;
        })
      )
      .subscribe();

    this.bpService.getChangeLogActions(this.bpId, this.bpVersion)
      .pipe(
        tap(acts => this.actions = acts, error1 => {
            let err = error1;
            if (error1.indexOf('401') !== -1) {
              err = 'Erro: Sessão expirada.';
            }
            this.error = err;
        } )
      )
      .subscribe();
  }

  filterData() {
    const emptyFilter = (this.actions && this.actions.length === 0) || this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter) {
      return this.actions;
    } else {
      return this.actions.filter(act => {
        return (
          ( act.elementTypeDesc.toLowerCase().includes(this.filterText.toLowerCase()) ||
            act.userLogon && act.userLogon.toLowerCase().includes(this.filterText.toLowerCase()) ||
            act.description && act.description.toLowerCase().includes(this.filterText.toLowerCase()) )
        );
      });
    }
  }

  onClose() {
    this.bsModalRef.hide();
  }

}
